export default __webpack_public_path__ + "static/media/stargrills_2.1d157d12.jpg";